var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCss3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "#2196f3",
    d: "M 31.5,-0.5 C 180.833,-0.5 330.167,-0.5 479.5,-0.5C 466.452,153.199 452.952,306.866 439,460.5C 379.01,477.286 319.177,494.286 259.5,511.5C 256.833,511.5 254.167,511.5 251.5,511.5C 191.823,494.286 131.99,477.286 72,460.5C 58.0485,306.867 44.5485,153.2 31.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cae3f7",
    d: "M 396.5,96.5 C 349.838,95.1667 302.838,94.5001 255.5,94.5C 208.162,94.5001 161.162,95.1667 114.5,96.5C 113.596,95.791 113.263,94.791 113.5,93.5C 208.167,93.5 302.833,93.5 397.5,93.5C 397.737,94.791 397.404,95.791 396.5,96.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f9f9",
    d: "M 396.5,96.5 C 388.805,191.593 380.138,286.593 370.5,381.5C 332.233,392.317 293.899,402.984 255.5,413.5C 216.933,403.609 178.6,392.942 140.5,381.5C 136.917,351.582 133.917,321.582 131.5,291.5C 150.735,290.866 169.735,291.532 188.5,293.5C 189.713,308.513 191.047,323.513 192.5,338.5C 213.449,343.987 234.449,349.321 255.5,354.5C 276.54,349.161 297.54,343.827 318.5,338.5C 321.753,312.225 324.419,285.891 326.5,259.5C 260.5,259.5 194.5,259.5 128.5,259.5C 126.503,241.534 124.836,223.534 123.5,205.5C 179.168,205.352 234.835,205.019 290.5,204.5C 304.5,204.5 318.5,204.5 332.5,204.5C 332.5,202.5 332.5,200.5 332.5,198.5C 333.784,181.184 334.784,163.85 335.5,146.5C 262.833,146.5 190.167,146.5 117.5,146.5C 116.146,129.856 115.146,113.189 114.5,96.5C 161.162,95.1667 208.162,94.5001 255.5,94.5C 302.838,94.5001 349.838,95.1667 396.5,96.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7abdf5",
    d: "M 332.5,198.5 C 332.5,200.5 332.5,202.5 332.5,204.5C 318.5,204.5 304.5,204.5 290.5,204.5C 303.99,203.504 317.656,203.171 331.5,203.5C 331.216,201.585 331.549,199.919 332.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a9d5f7",
    d: "M 131.5,291.5 C 150.326,290.503 169.326,290.17 188.5,290.5C 188.5,291.5 188.5,292.5 188.5,293.5C 169.735,291.532 150.735,290.866 131.5,291.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss3);
export default __webpack_public_path__ + "static/media/css-3.9b9ad3471229feb5faeea8b574204b81.svg";
export { ForwardRef as ReactComponent };